import { Fragment } from 'react';
import PropTypes from 'prop-types';
import Metrics from '@spotahome/soyuz-tracking';
import { trans } from '@spotahome/soyuz/client';
import SoyuzAnalytics from '@spotahome/soyuz-analytics';

import { Button, useModalHandle } from '@spotahome/ui-library';

import { useFavoriteConsumer } from '@spotahome/ui-library/src/tenant/context/FavoriteContext';
import { useShare } from '@spotahome/ui-library/src/tenant/context/ShareContext';

import ShareModal from './components/ShareModal';
import ShareButton from './components/ShareButton';

const shareNatively = listingId =>
  navigator
    .share({ url: window.location.href })
    .then(() => {
      Metrics.actions.sendActionEvent(Metrics.actions.SHARE_LISTING, {
        listingId
      });
      SoyuzAnalytics.sendGA4Event('share', {});
    })
    .catch(error => console.error('Error sharing', error));

const ShareModalWrapper = ({
  className = '',
  showText = false,
  deviceOS = ''
}) => {
  const { isModalOpen, handleModalOpen, handleModalClose } = useModalHandle();
  const { shareCount, incrementShare } = useShare();
  const { listingId } = useFavoriteConsumer();

  const handleShareModalOpen = () => {
    if (navigator?.share) {
      shareNatively(listingId).then(() => incrementShare('sharedNatively'));
    } else {
      Metrics.actions.sendActionEvent(Metrics.actions.SHARE_LISTING, {
        listingId
      });
      SoyuzAnalytics.sendGA4Event('share', {});
      handleModalOpen();
    }
  };

  return (
    <Fragment>
      <ShareButton
        onClick={handleShareModalOpen}
        className={className}
        deviceOS={deviceOS}
        count={shareCount}
      />
      <ShareModal
        isOpen={isModalOpen}
        onRequestClose={handleModalClose}
        listingId={listingId}
      />
      {showText && (
        <Button
          className={'share-button__text'}
          color="link"
          onClick={handleShareModalOpen}
        >
          {trans('listing.social-buttons.share')}
        </Button>
      )}
    </Fragment>
  );
};

ShareModalWrapper.propTypes = {
  className: PropTypes.string,
  showText: PropTypes.bool,
  deviceOS: PropTypes.string
};

export default ShareModalWrapper;
